// Components==============
import File from 'components/UI/TrainingContent/File/File';
import Image from 'components/UI/TrainingContent/Image/Image';
import Text from 'components/UI/TrainingContent/Text/Text';
import Video from 'components/UI/TrainingContent/Video/Video';
import React from 'react';
import './Content.module.scss';

export default function Content({
  content,
}: {
  content: TrainingLessonContent;
}) {
  const data = JSON.parse(content.block_data);

  if (content.block_type === 'file' && data.file_path)
    return (
      <File
        name={data.file_name}
        path={data.file_path?.replace('public', '/storage')}
      />
    );

  if (content.block_type === 'image' && data.file_path)
    return (
      <Image
        path={data.file_path?.replace('public', '/storage')}
        name={data.file_name}
      />
    );

  if (content.block_type === 'text' && data.value)
    return <Text text={data.value} />;

  if (content.block_type === 'video' && data.value)
    return <Video link={data.value} />;

  return <></>;
}
